import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  @Input() bcRight: Array<Array<number>> = [];
  @Input('pathList') pathListValue: Array<Array<string>> = [];

  constructor() { }

  ngOnInit(): void {
  }

  getTitle(): string {
    if (this.pathListValue[this.pathListValue.length -1]){
      return this.pathListValue[this.pathListValue.length -1][0];
    }
    return "";
  }

  isNotDashboard(): boolean {
    // Se non ci sono elementi o c'è solo la dashboard, ritorna false
    if (this.pathListValue.length === 0) {
      return false;
    }
    // Se c'è un solo elemento e punta a dashboard, ritorna false
    if (this.pathListValue.length === 1 && 
        (this.pathListValue[0][1] === '/dashboard' || 
         this.pathListValue[0][1] === 'dashboard')) {
      return false;
    }
    return true;
  }
}